/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import '@webex/internal-plugin-locus';
import '@webex/internal-plugin-metrics';
import '@webex/plugin-people';
import {registerPlugin} from '@webex/webex-core';

import Phone from './phone';
import config from './config';

export default Phone;
export {events as phoneEvents} from './phone';
export {default as Call} from './call';
export {default as boolToStatus} from './bool-to-status';

// exporting for testing purposes, hence not exporting the whole thing.
export {remoteParticipant} from './state-parsers';

export {default as StatsFilter} from './stats/filter';
export {default as StatsStream} from './stats/stream';

registerPlugin('phone', Phone, {config});
